// SelectFi Widget SDK - Main entry point

import { SelectfiWidgetSdk } from './core/SelectfiWidgetSdk';
import type { Options } from './core/types';

export interface SelectFiWidgetConfig {
  widgetKey: string;
  dealerMap?: Record<string, string>;
  testMode?: boolean;
}

declare global {
  interface Window {
    SelectfiWidgetSdk: {
      create: (options: Options) => Promise<SelectfiWidgetSdk>;
      rescan: () => void;
      debug: () => void;
      version: string;
    };
    _selectfiSdkInstance?: SelectfiWidgetSdk;
    dataLayer?: any[]; 
  }
}

(function(window: Window) {
  // double init protection
  if (window.SelectfiWidgetSdk) {
    console.warn('[SelectfiWidgetSdk] Double init prevented; ensure there is only one instance of the SDK script included.');
    return;
  }

  window.SelectfiWidgetSdk = {
    create: async function(options: Options): Promise<SelectfiWidgetSdk> {
      const instance = await SelectfiWidgetSdk.create(options);
      window._selectfiSdkInstance = instance;
      return instance;
    },
    rescan: function(): void {
      const sdkInstance = window._selectfiSdkInstance;
      if (sdkInstance) {
        sdkInstance.rescan();
      } else {
        console.warn('[SelectfiWidgetSdk] Cannot rescan: SDK instance not found.');
      }
    },
    debug: function(): void {
      const sdkInstance = window._selectfiSdkInstance;
      if (sdkInstance) {
        sdkInstance.debug();
      } else {
        console.warn('[SelectfiWidgetSdk] Cannot enable debug: SDK instance not found.');
      }
    },
    version: SelectfiWidgetSdk.version
  };
})(window);